import { Flex, Form, Radio, RadioChangeEvent, Space } from 'antd';
import { useState } from 'react';
import { Button } from '../../button/button';
import CustomRadio from '../../form/radio/radio';

interface VerificationMethodProps {
  // userEmail: string;
  availableMethods: string[];
  isSendingMFACode?: boolean;
  onMethodSelected: (method: string) => void;
}

export default function VerificationMethod({
  // userEmail,
  onMethodSelected,

  availableMethods = [],
  isSendingMFACode,
}: VerificationMethodProps) {
  const [value, setValue] = useState('email');
  const onChange = (e: RadioChangeEvent) => {
    setValue(e.target.value);
  };

  const handleFinish = (data: { verificationMethod: string }) => {
    onMethodSelected(data.verificationMethod === 'email' ? 'email' : 'sms');
  };

  return (
    <Flex vertical gap={16}>
      <h2>Select a verification method</h2>
      <p>How would you like to get your verification code?</p>
      <Form onFinish={handleFinish} initialValues={{ verificationMethod: 'email' }}>
        <Form.Item name="verificationMethod">
          <Radio.Group onChange={onChange} value={value}>
            <Space direction="vertical">
              {availableMethods.includes('email') && (
                <CustomRadio value="email">
                  <div>
                    <p>Email</p>
                  </div>
                </CustomRadio>
              )}
              {/* {availableMethods.includes('sms') && (
                <CustomRadio value="sms">
                  <div>
                    <p>SMS</p>
                  </div>
                </CustomRadio>
              )} */}
            </Space>
          </Radio.Group>
        </Form.Item>
        <Form.Item>
          <Button size="large" type="primary" htmlType="submit" block loading={isSendingMFACode}>
            Continue
          </Button>
        </Form.Item>
      </Form>
    </Flex>
  );
}
